import PropTypes from 'prop-types'
import classNames from 'classnames'
import { formatToCurrency } from '@/utils/format'
import styles from './styles.module.scss'
import { isArray } from 'lodash'
// import { usePromotionsData, useGetDiscounts, applyDiscounts } from '@saatva-bits/pattern-library.modules.promotions'
import { useExperiment } from '@saatva-bits/pattern-library.modules.launch-darkly'

/**
 * TODO: Move logic into the Strikethrough Bit components in Bit upon test finalization. Replace all instances of the StrikethroughVariant and Strikethrough with the bit component.
 * NOTES:
    * The majority of Coupons ONLY get applied to the cart items and are not considered while calculating discounts for other items such as recommendation strip products.
    * Items that use a ranged strikethrough need a list of all variants (and respective variant data) and the configurable attributes in the item object.
    * The non-ranged strikethrough is ONLY for cartItems right now.
 * @param {Object} item - The product data object. Must include the parent product configurable attributes and all variants if isRange is set to true.
 * @param {string} dataSelector - The data selector for the price container.
 * @param {string} priceContainerClassName - The class name for the price container.
 * @returns {JSX.Element} - The StrikethroughVariant component.
 */
const StrikethroughVariant = ({ item, dataSelector, priceContainerClassName, isRange = false }) => {
    const { isV1: PERCENT_OFF_STRIKETHROUGH_ON } = useExperiment('EXP.PERCENT_OFF_CART.CONV-321')
    // const promotionsData = usePromotionsData()
    // const { getDiscounts } = useGetDiscounts()

    if (!item) return null // If there is no item then return nothing
    // const sitewidePromo = promotionsData.sitewidePromo
    const originalPriceSelector = `${dataSelector}_originalPrice`
    const discountsPriceSelector = `${dataSelector}_discountsPrice`
    const products = isArray(item) ? item : [item]

    

    // TODO: Either update logic or remove after finalization of test. Range is not needed for current test.

    // Looks to see if any percentage off has been added from sitewide. The PromoProfile has too many other options that could be percentage or non-percentage based.
    // const isSitewidePromoPercentageType = sitewidePromo && sitewidePromo.percentAmounts && sitewidePromo.percentAmounts.length > 0
    // const renderStrikethroughRange = () => {
    //     let hasDiscounts = false
    //     let lowerDiscountPrice = item.lowestPrice
    //     let higherDiscountPrice = item.highestPrice

    //     // applyDiscounts gets discounts for all variants and then finds the lowest and highest discount amount to return as lowerPrice and upperPrice.
    //     const discountedItem = item.variants && item.configurableAttributes && applyDiscounts([item], getDiscounts)

    //     if (discountedItem && discountedItem.length) {
    //         const { lowerPrice, upperPrice, lowestPrice, highestPrice } = discountedItem[0]

    //         if (lowerPrice !== lowestPrice && upperPrice !== highestPrice && isSitewidePromoPercentageType) {
    //             hasDiscounts = true
    //             lowerDiscountPrice = lowerPrice
    //             higherDiscountPrice = upperPrice
    //         }
    //     }

    //     const rangedStrikethroughClasses = classNames(styles.price, {
    //         [styles.rangedPrice]: !hasDiscounts,
    //         [styles.strikethrough]: hasDiscounts
            
    //     })

    //     const rangedPriceClasses = classNames(styles.price, {
    //         [styles.isHidden]: !hasDiscounts
    //     })
        
    //     return (
    //         <>
    //             <h4 className={rangedStrikethroughClasses} data-selector={discountsPriceSelector}>{formatToCurrency(item.lowestPrice)} - {formatToCurrency(item.highestPrice)}</h4>
    //             {hasDiscounts && <h4 className={rangedPriceClasses} data-selector={originalPriceSelector}>{`${formatToCurrency(lowerDiscountPrice)} - ${formatToCurrency(higherDiscountPrice)}`}</h4>}
    //         </>
    //     )
    // }

    // TODO: update to be compatible with non cartItem object data. Non cart items to do not contain discounts value.
    // getDiscounts or applyDiscounts can be used to get the correct discounted amounts.
    const renderStrikethrough = () => {
        const { totalOriginalPrice, totalStrikethroughPrice } = products.reduce(
            (acc, product) => {
                const { discounts, price, quantity } = product
                let discountsPrice = 0
                /*
                    * Allow all discounts to be displayed if the experiment is running.
                    * Otherwise, remove all discounts.
                    * Save section below for after test.
                */

                // const discountsFiltered = discounts && discounts.filter((appliedDiscount) => {
                //     if (!sitewidePromo) return false
                //     let isStrikeThrough = true
                // const appliedDiscountIsSitewide = sitewidePromo.labels && sitewidePromo.labels.includes(appliedDiscount.label) // Verifies discount on item is a sitewide discount
                // const isAdditionalFixedOffDiscount = sitewidePromo.additionalFixedDiscount && sitewidePromo.additionalFixedDiscount.label === appliedDiscount.label

                // // If the sitewide promotion is not a % off and 
                // // the applied discount is from the sitewide sale then do not add it in the strikethrough
                // if (!isSitewidePromoPercentageType && appliedDiscountIsSitewide) {
                //     isStrikeThrough = false
                // }

                // // Additional fixed off promos can be applied with a percentage off sitewide promo.
                // if (isAdditionalFixedOffDiscount) {
                //     isStrikeThrough = false
                // }

                // // TODO: REMOVE ONCE DISCOVER ADDS CUSTOM LABELS TO SITEWIDE PROMO DATA
                // if (appliedDiscount.label === 'MORE SLEEP, MORE SAVINGS' || appliedDiscount.label === 'Buy More Save More') {
                //     isStrikeThrough = false
                // }

                // return isStrikeThrough
                // })

                // discountsFiltered && discountsFiltered.forEach((appliedDiscount) => {
                //     discountsPrice += appliedDiscount.amount // total sum of discounts applied. Inherently includes quantity.
                // })

                discounts?.forEach((appliedDiscount) => {
                    discountsPrice += appliedDiscount.amount // total sum of discounts applied. Inherently includes quantity.
                })
            
                const originalPrice = price * quantity // Original price of product(s) to display
                const totalStrikethrough = originalPrice - discountsPrice // Strikethrough price of product(s) to display. Total original price - total discounts

                return {
                    totalOriginalPrice: acc.totalOriginalPrice + originalPrice,
                    totalStrikethroughPrice: acc.totalStrikethroughPrice + totalStrikethrough,
                    totalDiscountsPrice: acc.totalDiscountsPrice + discountsPrice,
                }
            },
            { totalOriginalPrice: 0, totalStrikethroughPrice: 0, totalDiscountsPrice: 0 }
        )

        const samePrice = totalStrikethroughPrice === totalOriginalPrice
        const showStrikethrough = PERCENT_OFF_STRIKETHROUGH_ON && !samePrice
        const priceSelector = showStrikethrough ? discountsPriceSelector : originalPriceSelector
        const realPrice = showStrikethrough ? totalStrikethroughPrice : totalOriginalPrice

        return (
            <>
                {showStrikethrough && <h4 className={styles.strikethrough} data-selector={originalPriceSelector}>{formatToCurrency(totalOriginalPrice)}</h4>}
                <h4 className={styles.price} data-selector={priceSelector}>{formatToCurrency(realPrice)}</h4>
            </>
        )
    }

    const priceContainerClasses = classNames(styles.priceContainer, {
        [`${priceContainerClassName}`]: priceContainerClassName,
        [styles.isRange]: isRange
    })

    return (
        <div className={priceContainerClasses}>
            {/* { isRange ? renderStrikethroughRange() : renderStrikethrough() } */}
            {renderStrikethrough()}
        </div>
    )
    
}

StrikethroughVariant.propTypes = {
    item: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    dataSelector: PropTypes.string.isRequired,
    priceContainerClassName: PropTypes.string,
    isRange: PropTypes.bool
}

export default StrikethroughVariant
